import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
    
const store = new Vuex.Store({
    state:{
        dataWeb:{
            imgSliders:[],
            staff:[],
            phone: '',
            whatsapp: '',
            facebook: '',
            instagram: '',
            twitter: '',
            telWhatsapp: '',
            msgWhatsapp: '',
            
        },
        barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
        barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
        drawer: true,
        loadingBtn : false,
        dialog:false,
        loadingBtn2 : false,
        items:0,
        userVerificated:false,
        idActionsRol:[],
        url:'',
        listNotificationsAction:false,
        cantNotifications:0,
        notifications:[],
        notificationsWithoutQuote:[],
        listNotificationsActionWithoutQuote:false,
        cantNotificationsWithoutQuote:0,
        totalQuantity:0,
        user:null,
        loadingTable:false,
        token: '',
        alertas:'',
        loggedIn:false,
        checkout:false,
        shoppingCar:[],
        scrollTop:false,
        selectedProducts:[],
        lastProductsVisited:[],
        pathFileOrder:'/home/ronald/html/resultados/pdf/',
        directoryPDF:'/home/ronald/html/resultados/pdf/',
        directoryTemp:'/home/ronald/html/resultados/temp/',
        directoryFileQuote:'/home/ronald/html/formularios-web/',
        directoryComplement:'/home/ronald/html/resultados/complement/',
        pathFileProducts:'img/products/',
        urlApi : process.env.VUE_APP_NODE_ENV === "production" ? process.env.VUE_APP_API_URL_PROD : process.env.VUE_APP_API_URL_DEVEL,
        sweetAlert:{
            title:'Éxito',
            html:'',
            icon:'success',
            toast:true,
            timer:5000,
            confirmButtonText :'<span class="mdi mdi-close-circle-outline"></span> Cerrar',
            timerProgressBar: true,
            position:'top',
            confirmButtonColor: '#a5dc86',
        },
        sweealertForms:{
            html: 'Muchas gracias, le responderemos en breve.',
            icon:'success',
            confirmButtonColor:'#50c995',
            toast:false,
            grow:false,
            position:'center',
            confirmButtonText:'Cerrar'
        },
        sweeAlertAddProduct:{
            html: ' Producto agregado a su compra',
            icon:'success',
            confirmButtonColor:'#50c995',
            toast:true,
            grow:'row',
            position:'top-end',
            timer:1500,
            timerProgressBar:true,
            showConfirmButton:false
        },
        statesListOrder:[
            {status_id : '' , name : 'Seleccione'},
            {status_id : 'OLST_SOLICITADA' , name : 'Solicitado'},
            {status_id : 'OLST_COMPLETADA' , name : 'Completada'}
        ],
        paramAlertQuestion:{
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText:'Cancelar',
            confirmButtonText: 'Aceptar!'
        }
    },
    mutations: {

        setDrawer (state) {
            state.drawer = !state.drawer
        },

        setDialog(state){
            state.dialog = !state.dialog
        },

        setLoadingBtn(state) {
            state.loadingBtn = !state.loadingBtn
        },

        setLoadingBtn2(state) {
            state.loadingBtn2 = !state.loadingBtn2
        },

        setSeewtNotification(state,payload){

            if(typeof payload.timer != "undefined")
                state.sweetAlert.timer = payload.timer

            if(typeof payload.title != "undefined")
                state.sweetAlert.title = payload.title

            if(typeof payload.icon != "undefined")
                state.sweetAlert.icon = payload.icon

            if(typeof payload.toast != "undefined")
                state.sweetAlert.toast = payload.toast

            if(typeof payload.confirmButtonColor != "undefined")
                state.sweetAlert.confirmButtonColor = payload.confirmButtonColor

            state.sweetAlert.html = payload.html

        },

        setLoadingTable(state,payload){
            state.loadingTable = payload
        },

        setToken(state,payload){
            state.token = payload
        },

        setUser(state,payload){
            state.user = payload
        },

        setLogedIn(state,payload){
            state.loggedIn = payload
        },

        setAccessView(state,payload){
            state.accessView=payload
        },

        setUrl(state,payload){
            state.url =state.urlApi+payload
        },

        setActionsRol(state){
            if(localStorage.getItem('user')!=""){
                let user = JSON.parse(localStorage.getItem('user'))
                for (let permission of user.permission){
                    let action = state.idActionsRol.find(e => e === permission)
                    if(typeof action == "undefined")
                        state.idActionsRol.push(permission)
                }
            }else{
                state.idActionsRol=[]
            }
            
        },

        setNotifications(state,payload){
            state.listNotificationsAction = payload.items.length > 0
            state.cantNotifications =  payload.items.length
            state.notifications = payload.items
            state.listNotificationsActionWithoutQuote = payload.quote.length > 0
            state.cantNotificationsWithoutQuote =  payload.quote.length
            state.notificationsWithoutQuote = payload.quote
        },

        itemShoppingCar(state,payload){
     
            state.shoppingCar = payload
            
            localStorage.setItem('shoppingCar',JSON.stringify(state.shoppingCar))
            
            let quantities=  state.shoppingCar.map(obj=>{ return obj.quantity })

            let quantity= 0
            if(state.shoppingCar.length)
                quantity= quantities.reduce((accumulator, currentValue) => accumulator + currentValue)
            
            state.totalQuantity = quantity
            
        },

        deleteItemShoppingCar(state,payload){
            let a= state.shoppingCar
            a.splice(payload,1)

            state.shoppingCar = a
            state.totalQuantity-= payload.quantity
            /* let obj= state.shoppingCar.find(payload)
            console.log(obj)
            let index= state.shoppingCar.indexOf(obj) */
            
        },

        setScrollTop(state,payload){
            state.scrollTop=payload
        },

        setTotalQuantity(state,payload){
            state.totalQuantity = payload
        },
        
        setCheckout(state,payload){
            state.checkout= payload
        },

        setSelectedProducts(state,payload){
            state.selectedProducts.push(payload)
        },

        deleteSelectedProducts(state,payload){
            state.selectedProducts = []
        },

        setLastProductsVisited(state,payload){
            
            if(localStorage.getItem('lastProductsVisited')!="" && localStorage.getItem('lastProductsVisited')!=null){

                let objLastProductsVisited = JSON.parse(localStorage.getItem('lastProductsVisited'))

                let existsProduct = objLastProductsVisited.find(e => e.product_id == payload.product_id)
                
                typeof existsProduct == 'undefined' && objLastProductsVisited.push({product_id:payload.product_id})

                localStorage.setItem('lastProductsVisited',JSON.stringify(objLastProductsVisited))

                state.lastProductsVisited = JSON.parse(localStorage.getItem('lastProductsVisited'))

            }else{

                localStorage.setItem('lastProductsVisited',JSON.stringify([{product_id:payload.product_id}]))

            }

        },

        setUserVerificated(state,payload){
            state.userVerificated = payload
        },

        setFrontDataWeb(state,payload) {

            for (const item of payload) {

                if(item.content_type_id == 'TLF_FIJO'){

                    state.dataWeb.phone = item.content_name
                    this.phoneId = item.content_id

                }else if(item.content_type_id == 'TLF_MOVIL'){

                    state.dataWeb.whatsapp= item.content_name
                    this.whatsappId = item.content_id

                }else if(item.content_type_id == 'FACEBOOK'){

                    state.dataWeb.facebook= item.content_name
                    this.facebookId = item.content_id

                }else if(item.content_type_id == 'INSTAGRAM'){

                    state.dataWeb.instagram= item.content_name
                    this.instagramId = item.content_id

                }else if(item.content_type_id == 'TWITTER'){

                    state.dataWeb.twitter= item.content_name
                    this.twitterId = item.content_id

                }else if(item.content_type_id == 'TLF_WATHSAPP'){

                    state.dataWeb.telWhatsapp= item.content_name
                    this.telWhatsappId= item.content_id

                }else if(item.content_type_id == 'MENSAJE_WATHSAPP'){

                    state.dataWeb.msgWhatsapp= item.content_name
                    this.msgWhatsappId = item.content_id

                }
                
            }

            state.dataWeb.imgSliders = payload.filter(e => e.content_type_id == 'IMG_SLIDER_WEB')

            state.dataWeb.staff = payload.filter(e => e.content_type_id == 'IMG_PERSONAL_WEB')

        },

        setSedeService(state,payload){

            state.dataWeb.service= payload
        }

    },
    actions:{

        errorRequest({commit,state,dispatch},payload){
            console.log("entró en el errorRequest")
            state.alertas='';
            let errorValidacion=false;

            errorValidacion = payload.data.status === 422

            if(errorValidacion){ // ERROR DE VALIDACION DEL REQUEST
                
                let messages = payload.data.response.data.validation_messages

                Object.keys(payload.data.response.data.validation_messages).forEach(item => {
                    let msg = messages[item];
                    for(let i = 0; i < msg.length; i++)
                        state.alertas += msg[i] + '<br />';
                });

            }else if(payload.data.status===500){ // MAYORMENTE ERROR DE PROGRAMACIÓN
                if(typeof payload.data.datos != "undefined"){
                    let i =1;
                    Object.keys(payload.data.datos).forEach(item => {
                        let msg = payload.data.datos[item];
                        if(i<5)
                            state.alertas += item+' '+msg + '<br />';
                        i++;
                    });
                }else{
                    console.log(payload)
                    state.alertas += payload.data.response.data.detail
                }
            }else{
                state.alertas = 'Ha ocurrido un error inesperado, intente nuevamente';
            }

            if(typeof payload.data.btn == "undefined" && state.loadingBtn)
                commit('setLoadingBtn')
            else if(payload.data.btn===2)
                commit('setLoadingBtn2')

            let error500 = !(typeof payload.data != "undefined" && payload.data.status===500)

            let data ={
                param:{
                    title: 'Error!',
                    html: state.alertas,
                    icon: 'error',
                    toast: error500,
                    timer: !error500 ? 25000 : state.sweetAlert.timer,
                    position: state.sweetAlert.position,
                    confirmButtonColor : '#d60400'
                }
            }
            dispatch('alertNotification',data)

        },

        alertNotification({commit,state},payload){

            commit('setSeewtNotification',{
                html : payload.param.html,
                timer : payload.param.timer,
                title : payload.param.title,
                icon : payload.param.icon,
                toast : payload.param.toast,
                confirmButtonColor: payload.param.confirmButtonColor
            });

            Vue.swal({
                title: state.sweetAlert.title,
                html: state.sweetAlert.html,
                icon: state.sweetAlert.icon,
                toast: state.sweetAlert.toast,
                timerProgressBar : state.sweetAlert.timerProgressBar,
                timer: state.sweetAlert.timer,
                position: state.sweetAlert.position,
                confirmButtonText : state.sweetAlert.confirmButtonText,
                grow:'row',
                confirmButtonColor: state.sweetAlert.confirmButtonColor,
            });

            commit('setSeewtNotification',{
                title:'Éxito',
                icon:'success',
                toast:true,
                timer:5000,
                confirmButtonColor: '#a5dc86',
            });
        },

        loginAction({commit,state,dispatch}, payload) {

            return new Promise( (resolve, reject) => {

                commit('setLoadingBtn')

                axios.post(state.url, {
                    client_id: payload.user,
                    client_secret: payload.password,
                    grant_type : 'client_credentials'
                }).then(res => {

                    if (res.statusText === "OK" && res.status === 200 && res.data.access_token)  {

                        let token = res.data.access_token
                        localStorage.setItem('token',token)

                        commit('setUrl','user-laboratorio')
                       
                        axios.post(state.url, {
                            tenantId: process.env.VUE_APP_TENANT,
                            client_id: payload.user,
                            user: payload.user,
                            system: 'web-page',
                            dataBase: 'obfinnofarm',
                            comment : 'ha iniciado sesión en la web de innofarm',
                            accesoWebEcommerce: true
                        }).then(res=>{

                            let user = JSON.stringify(res.data.user)
                            localStorage.setItem('user', user)
                            dispatch('checkSessionStatus')
                            commit('setLoadingBtn')

                            dispatch('alertNotification',{
                                param: {
                                    html: 'Bienvenido ' + res.data.user.name
                                }
                            })

                            resolve(res)

                        }).catch(err => {

                            reject(err)

                        })
                    }

                }).catch(err => {
                    reject(err)
                    
                    if(!state.loadingBtn) 
                        commit('setLoadingBtn')

                    let response = err.response
                    
                    console.log(err,response)
                    
                    if(!response.data.login || response.data.status==400){
                        dispatch('alertNotification',{
                            param:{
                                title:'Error',
                                icon:'error',
                                html: 'El usuario o contraseña son incorrectos',
                                confirmButtonColor:'#d60400'
                            }
                        })
                    }else{
                        dispatch('errorRequest',{
                            data : {
                                datos: response.data.errors,
                                status : response.status,
                            }
                        });
                    }
                    commit('setLoadingBtn')
                })

            })

        },

        logoutAction({commit,state,dispatch},payload){

            return new Promise((resolve,reject) =>{

                axios.delete(state.url,{
                   
                    access_token : state.token,
                   
                }).then(res =>{

                    resolve(res)

                    localStorage.removeItem('token')
                    localStorage.setItem('user','')
                    commit('setLogedIn',false)
                    commit('setActionsRol')


                    if(!payload.unAutorized){
                        dispatch('alertNotification',{
                            param:{
                                html: 'Adios '+ state.user.name
                            }
                        });
                    }

                }).catch(err =>{

                    reject(err)

                    let response = err.response;
                    dispatch('errorRequest',{
                        data : {
                            datos: response.data.errors,
                            status : response.status,
                        }
                    });

                });

            })

        },

        checkSessionStatus({commit}){
            
            let token = localStorage.getItem('token')
            let existToken = token !=null && token !== undefined && typeof token !== "undefined"
            
            if(existToken){
                commit('setToken',token, { root: true })
                
                if(localStorage.getItem('user') != null){
                    commit('setUser',JSON.parse(localStorage.getItem('user')), { root: true })
                    commit('setActionsRol')
                    commit('setLogedIn',true)
                }
               
            }

        },

        unAutorized({state,commit,dispatch}){

            dispatch('logoutAction',{
                unAutorized : true
            })

        },

        requestApi({state,commit,dispatch},payload){
            let body =  {params: payload.data}
            if(payload.method === 'POST' || payload.method === 'DELETE' || payload.method === 'PATCH' || payload.method === 'PUT')
                body = {data: payload.data}

            return new Promise((resolve,reject) => {
            
                axios({
                    method:payload.method,
                    url: state.url,
                    ...body,
                    headers:{
                        Authorization: 'Bearer '+ state.token
                    },
                }).then(res => {

                    resolve(res)

                }).catch(err => {

                    reject(err)

                });
            })
        },

        getNotifications({state,commit,dispatch}){
            commit('setUrl','ordenes-laboratorio/1')
            return new Promise((resolve,reject) => {

                dispatch('requestApi',{
                    method: 'PATCH',
                    data:{
                        preview : 'dfbweiy'
                    }
                }).then(res => {
                    resolve(res.data) 
                })

            })
            
        },

        login({state,commit,dispatch},payload){
          
            return new Promise( (resolve, reject) => {

                commit('setLoadingBtn')
                commit('setUrl','oauth')
                axios.post(state.url, {
                    client_id: payload.user,
                    client_secret: payload.password,
                    grant_type : 'client_credentials'
                }).then(res => {

                    resolve(res)

                    if (res.statusText === "OK" && res.status === 200 && res.data.access_token)  {

                        let token = res.data.access_token
                        localStorage.setItem('token',token)

                        commit('setUrl','user-laboratorio')
                        axios.post(state.url, {
                            tenantId:'INNOCLINICA',
                            client_id: payload.user,
                            system: 'laboratorio',
                            dataBase: 'obinnoclinica',
                            comment : 'ha iniciado sesión en el sistema de consultas de examenes médicos del laboratorio',
                            accesoWebEcommerce:true
                        }).then(res=>{
                            let userString = JSON.stringify(res.data.user)
                            localStorage.setItem('user', userString)
                            dispatch('checkSessionStatus')
                            commit('setLoadingBtn')
                            typeof state.idActionsRol.find(e => e === 'ACCESO_WEB_ADMIN') != "undefined"
                                ? router.push('/admin_ordenes')
                                : router.push('/ordenes')

                            dispatch('alertNotification',{
                                param: {
                                    html: 'Bienvenido ' + payload.user
                                }
                            });
                        })
                    }

                }).catch(err => {
                    reject(err)
                    
                    if(!state.loadingBtn) commit('setLoadingBtn')
                    let response = err.response;
                    console.log(err,response)
                    
                    if(!response.data.login){
                        dispatch('alertNotification',{
                            param:{
                                title:'Error',
                                icon:'error',
                                html: 'El usuario o contraseña son incorrectos',
                                confirmButtonColor:'#d60400'
                            }
                        })
                    }else{
                        dispatch('errorRequest',{
                            data : {
                                datos: response.data.errors,
                                status : response.status,
                            }
                        });
                    }
                    commit('setLoadingBtn')
                })

            })



            /* commit('setUrl','oauth')
            dispatch('loginAction',({
                user : payload.user,
                password: payload.password,
            }).then(res =>{
                commit('setLoadingBtn')
                if(res.statusText === "OK" && res.status === 200 && typeof res.data.access_token != "undefined"){
                    commit('setLoadingBtn')
                    this.setUrl('user-laboratorio')
                    this.requestApi({
                        method:'POST',
                        data:{
                            client_id: payload.user,
                            system: 'laboratorio',
                            dataBase: 'obinnoclinica',
                            comment : 'ha iniciado sesión en el sistema de consultas de examenes médicos del laboratorio'
                        }
                    })
                    .then(res=>{
                        let userString = JSON.stringify(res.data.user)
                        localStorage.setItem('user', userString)
                        dispatch('checkSessionStatus')
                        commit('setLoadingBtn')
                        typeof state.idActionsRol.find(e => e === 'ACCESO_WEB_ADMIN') != "undefined"
                            ? router.push('/admin_ordenes')
                            : router.push('/ordenes')
                        
                    })

                   
                }

            }) */
        },

        dataCarousel({state,commit,dispatch},payload){

            let dividendo= payload.selectProduct.length/6
            let productsComplement =[]
           
            if (payload.width <= 370){
                dividendo = payload.selectProduct.length
            }else if (payload.width <= 450){
                dividendo = payload.selectProduct.length/2
            }else if (payload.width <= 663){
                dividendo = payload.selectProduct.length/3
            }else if (payload.width <= 1115){
                dividendo = payload.selectProduct.length/4
            }else if (payload.width <= 1240){
                dividendo = payload.selectProduct.length/5
            }else{
                dividendo = payload.selectProduct.length/5
            }
         
            let cantCarrousel = Math.round(payload.selectProduct.length/dividendo)
            
            let cantIngCarousel1 = 0

            for(let i=0; i<= dividendo; i++){
                if(cantIngCarousel1 < payload.selectProduct.length){
                    let prod=[]
                    for(let j=cantIngCarousel1; j<(cantIngCarousel1+cantCarrousel) ;j++)
                        if(typeof payload.selectProduct[j] !='undefined')
                            prod.push(payload.selectProduct[j])
                    
                    productsComplement.push(prod)
                    cantIngCarousel1+=cantCarrousel
                }
            }

            cantCarrousel = productsComplement.length
               
            productsComplement.forEach((obj, x, arr)=>{
                
                if(obj.length < 6 && productsComplement.length == (x+1)){
                   
                    for(let i = obj.length; i < 6; i++){
                        arr[x].push({
                            medium_image_url: '',
                            product_id: '',
                            product_name_web: '',
                            url_product: ''
                        }) 
                    }
                }
            })
            return {cantCarrousel, productsComplement}

        },

        getDataFrontWeb({state,commit,dispatch},payload){

            commit('setUrl','administracion')

            dispatch('requestApi',{
                method: 'GET',
                data:{
                    typeList:'dataWeb',
                    all: false
                }
            }).then(res => {
              
                commit('setFrontDataWeb', res.data._embedded.administracion)

            })

        },

        updateQuoteItems({state,getters,commit,dispatch},payload){
           
            return new Promise((resolve, reject)=>{

                let quoteId = localStorage.getItem('quote_id')
                
                if(getters.getIsLoggedIn && quoteId == null){

                    commit('setUrl','cotizacion-web')
                    
                    dispatch('requestApi',{
                        method: 'POST',
                        data:{
                            partyId: state.user.party_id,
                            userLoginId : state.user.user_ligin_id,
                            //items: JSON.stringify(state.shoppingCar)
                        }
                    }).then(res=>{

                        localStorage.setItem('quote_id',res.data.detail.quoteId)
                        resolve()
                        dispatch('updateQuote',payload)
                        .then(()=>{
                            resolve()
                        })

                    })

                }else{

                    dispatch('updateQuote',payload)
                    .then(res=>{

                        resolve(res)
                        
                    })
                    
                }

            })

        },

        updateQuote({state,getters,commit,dispatch},payload){

            return new Promise((resolve, reject)=>{

                let products = state.shoppingCar
                let quoteId = localStorage.getItem('quote_id')
    
                if(getters.getIsLoggedIn && quoteId != null){
        
                    commit('setUrl','cotizacion-web')
                    
                    dispatch('requestApi',{
                        method: 'PUT',
                        data:{
                            data:{
                                userLoginId: state.user.user_ligin_id,
                                items: products,
                                quoteId,
                                ...payload
                            }
                        }
                    }).then(res => {
                        
                        const { msg, quoteItems, rescpp, respp } = res.data.detail

                        Vue.swal({
                            html: msg,
                            icon:'success',
                            confirmButtonColor:'#50c995',
                            toast:true,
                            grow:'row',
                            position:'top-end',
                            timer:1500,
                            timerProgressBar:true,
                            showConfirmButton:false
                        })

                        console.log('quoteItems',quoteItems)

                        if(payload.action == 'add' && quoteItems.length){
                            
                            products=[]
                            commit('deleteSelectedProducts')

                            quoteItems.forEach(e =>{

                                let obj ={
                                    product_id : e.product_id,
                                    internal_name: e.internal_name,
                                    quantity: parseInt(e.quantity),
                                    images: e.images,
                                    tax_value: parseFloat(e.tax_value),
                                    price: parseFloat(e.price),
                                    brand_name: e.brand_name,
                                    quoteItemSeqId: e.quote_item_seq_id,
                                    psicotropico: e.psicotropico,
                                    inventory: e.inventory,
                                    is_promo: parseFloat(e.is_promo),
                                    valor_descuento: parseFloat(e.valor_descuento)
                                }

                                products.push(obj)

                                commit('setSelectedProducts',obj)    
                    
                            })
                            
                            commit('itemShoppingCar',products)    

                        }

                        resolve(res)

                    }).catch(err=>{
                        
                        //reject(err)

                    })

                }
            })

        }

    },
    getters:{
        getIsLoggedIn(state){
            return state.loggedIn
        }
    }
})

export default store
